<div class="container-fluid">
    <div class="d-flex  justify-content-between pt-3">
        <div class="d-flex mt-2 pointer" [routerLink]="['/report']">
            <div class="backicon">
                <i class="fa fa-arrow-left"></i>
            </div>
            <h3>GHG Emisisons Data - Mutiple Categories & Facilities</h3>
        </div>
        <div class="d-flex gap-3 align-items-center">
            <!-- <label class="switch">
                <input type="checkbox" >
                <span class="slider round"></span>
            </label> -->
            <!-- <p-triStateCheckbox [(ngModel)]="isMultiple" inputId="tricheckbox"></p-triStateCheckbox> -->
            <!-- <label for="tricheckbox" class="ml-2">Multiple</label> -->
            <p-dropdown *ngIf="isMultiple" class="ct_grop_select_2_drop_white123 ct_group_select_dark_124 mx-4" required
            ngModel placeholder="select" [options]="reportType"
            [(ngModel)]="selectReportType" optionLabel="value" optionValue="value"
            name="group" #group="ngModel"></p-dropdown>
        </div>
    </div>

    <div class="row firstbox">
        <div class="col">
            <div class="row mt-4  text-white">
                <ng-container *ngIf="isMultiple">
                    <div class="col-md-6 mb-3">
                        <label for="fyear" class="text-dark">Start Month</label>

                        <p-dropdown class="finput ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                            [options]="reportmonths" placeholder="Months" name="months" [(ngModel)]="startMonth"
                            optionLabel="name"></p-dropdown>

                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="fyear" class="text-dark">Start Year</label>
                        <div class="selectyear mx-0">
                            <p-calendar placeholder="Select Year" #calendarRef
                                class="calenderinput ct_border_none_input ct_input_dark_text_145 ct_year_input_full_w"
                                [(ngModel)]="startYear" view="year" dateFormat="yy" inputId="yearpicker"></p-calendar>

                            <div class="icon-wrapper">
                                <i class="pi pi-chevron-down" (click)="openCalendar(calendarRef)"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="fyear" class="text-dark">End Month</label>

                        <p-dropdown class="finput ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                            [options]="reportmonths" placeholder="Months" name="months" [(ngModel)]="endMonth"
                            optionLabel="name"></p-dropdown>

                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="fyear" class="text-dark">End Year</label>
                        <div class="selectyear mx-0">
                            <p-calendar placeholder="Select Year" #calendarRef
                                class="calenderinput ct_border_none_input ct_input_dark_text_145 ct_year_input_full_w"
                                [(ngModel)]="endYear" view="year" dateFormat="yy" inputId="yearpicker"></p-calendar>

                            <div class="icon-wrapper">
                                <i class="pi pi-chevron-down" (click)="openCalendar(calendarRef)"></i>
                            </div>
                        </div>
                    </div>

                </ng-container>
                <ng-container *ngIf="!isMultiple">
                    <div class="col-md-6 mb-3">
                        <label for="fyear" class="text-dark">Financial Year</label>
                        <div class="selectyear mx-0">
                            <p-calendar placeholder="Select Year" #calendarRef
                                class="calenderinput ct_border_none_input ct_input_dark_text_145 ct_year_input_full_w"
                                [(ngModel)]="date" view="year" dateFormat="yy" inputId="yearpicker"></p-calendar>

                            <div class="icon-wrapper">
                                <i class="pi pi-chevron-down" (click)="openCalendar(calendarRef)"></i>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="fyear" class="text-dark">Month</label>
                        <div
                            class="ct_box_shadow_none selectmonth card justify-content-center ct_month_select_clr ct_multi_input_38 ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145 ct_month_light_green">
                            <p-multiSelect [options]="reportmonths" placeholder="Months" name="months"
                                [(ngModel)]="selectMonths" styleClass="pcalender" optionLabel="name"></p-multiSelect>
                        </div>
                    </div>
                </ng-container>


            </div>
            <div class="row mt-4  text-white">
                <div class="col-md-6 mb-3">
                    <label for="fname" class="text-dark">Facility</label>
                    <ng-container *ngIf="isMultiple; else defaultfacilitydropdown">
                        <div
                            class="ct_box_shadow_none selectmonth card justify-content-center ct_month_select_clr ct_multi_input_38 ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145 ct_month_light_green">
                            <p-multiSelect [options]="facilityData"
                                [(ngModel)]="selectedMultipleFacility" optionLabel="AssestType" optionValue="id"
                                styleClass="pcalender" defaultLabel="Select Multiple Data Points" name="facility">
                            </p-multiSelect>
                        </div>
                    </ng-container>
                    <ng-template #defaultfacilitydropdown>
                        <p-dropdown class=" finput ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                            name="facility" #facility="ngModel" [options]="facilityData"
                            optionLabel="AssestType" optionValue="id" styleClass="facilitydropdown"
                            [(ngModel)]="selectedFacilityID">
                        </p-dropdown>
                    </ng-template>
                </div>


           


                <div class="col-md-6 mb-3">
                    <label for="fname " class="text-dark">Data points</label>
                    <ng-container *ngIf="isMultiple; else defaultCatName">
                        <div
                            class="ct_box_shadow_none selectmonth card justify-content-center ct_month_select_clr ct_multi_input_38 ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145 ct_month_light_green">
                            <p-multiSelect [options]="AssignedDataPoint" [(ngModel)]="selectedMultipleCategories"
                                optionLabel="CatName" optionValue="Id" styleClass="pcalender"
                                defaultLabel="Select Multiple Data Points" name="multipleDataPoints"
                                (onChange)="multipleDataPointsChanged($event)">
                            </p-multiSelect>
                        </div>
                    </ng-container>
                    <ng-template #defaultCatName>
                        <p-dropdown class="ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                            [options]="AssignedDataPoint" defaultLabel="Select Data Points"
                            [(ngModel)]="selectedCategory" optionLabel="CatName" optionValue="Id" display="chip"
                            name="datapoint" (onChange)="dataPointChangedID(selectedCategory)"></p-dropdown>
                    </ng-template>
                </div>


         

                <div class="col-md-6 mb-3" *ngIf="modeShow">
                    <label for="fname " class="text-dark">Mode of Travel</label>
                    <p-dropdown class="ct_input_white_bg13 ct_select_2_drop_white ct_input_dark_text_145"
                        [options]="Modes" defaultLabel="Select Data Points" [(ngModel)]="selectMode" placeholder="Select Mode"
                        optionLabel="modeType" optionValue="id" name="datapoint"></p-dropdown>
                </div>
            </div>
            <div class="row">
                <div class="pt-5">
                    <button (click)="newgenerateReport()"
                        class="generateReportButton ct_report_button_12 ct_animation_btn_121 ml-3">
                        Generate Report
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row Secondbox" *ngIf="reportData.length >0">
        <div class="col">
            <div class="row mt-4 mx-2 text-white">
                <div class="col d-flex justify-content-between">
                    <h4>Report</h4>
                    <button (click)="exportTableToExcel()"
                        class="generateReportButton ct_report_button_12 ct_animation_btn_121 ml-3">Download
                        Report</button>
                </div>
                <!-- <div *ngIf="CustomReportData && CustomReportData.length > 0"
                    class="col d-flex justify-content-end pointer">
                    Download
                    <i class="pi pi-download pl-2 pt-1 pointer mb-1" aria-hidden="true" id="downloadIcon"
                        data-toggle="dropdown" aria-haspopup="true" title="download" aria-expanded="false"></i>

                    <div class="dropdown-menu brsr dropdown-menu-right" aria-labelledby="downloadIcon">
                        <a class="dropdown-item pointer" value="Download PDF" (click)="downloadAsPDF()">
                            <i class="fas fa-file-pdf" style="color: red"></i>&nbsp;&nbsp; Download as PDF</a>
                    </div>
                </div> -->
            </div>
            <div class="row">
              

                <ng-container *ngIf="isMultiple else default">
                    <div class="col-md-12" *ngIf="reportData.length >0; else emptyList">

                        <p-table class="ct_bottom_table_tr ct_chev_icon_dark230" [paginator]="true" [rowHover]="true"
                            [rows]="500" [rowsPerPageOptions]="[10, 20, 50, 100,500]" [showCurrentPageReport]="true" 
                            styleClass="statusTable ct_status_tble_230_space ct_status_table_main"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" #dt1
                            class="ct_bottom_table_tr" #dt [value]="reportData" [rowHover]="true"
                            styleClass="p-datatable-striped" editMode="row">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>
                                        Category
                                    </th>
                                    <th>
                                        Data Point 1
                                    </th>
                                    <th>
                                        Data Point 2
                                    </th>
                                    <th>
                                        Facility
                                    </th>
                                    <th>
                                        Emissions (tCO2e)
                                    </th>
                                    <th *ngIf="!this.isMultiple || (this.isMultiple && this.selectReportType == 'Monthly')">
                                        Month
                                    </th>
                                    <th *ngIf="!this.isMultiple || (this.isMultiple && this.selectReportType == 'Monthly')">
                                        Year
                                    </th>
                                    <th *ngIf="this.isMultiple && this.selectReportType == 'Consolidated'">
                                        Time period
                                    </th>

                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-de let-editing="editing" let-ri="rowIndex">
                                <tr [pEditableRow]="de">

                                    <td> {{de.category}}</td>
                                    <td> {{de.DataPoint1}}</td>
                                    <td> {{de.DataPoint2}}</td>
                                    <td> {{de.facility}}</td>
                                    <td>{{ (+de.Emission / 1000) | number: '1.4-4' }}</td>
                                    <td *ngIf="!this.isMultiple || (this.isMultiple && this.selectReportType == 'Monthly')"> {{de.Months}}</td>
                                    <td *ngIf="!this.isMultiple || (this.isMultiple && this.selectReportType == 'Monthly')"> {{de.Years}}</td>
                                    <td *ngIf="!this.isMultiple || (this.isMultiple && this.selectReportType == 'Consolidated')"> {{startMonth.value + ' '+ startYear.getFullYear().toString() + '-'+ endMonth.value + ' '+ endYear.getFullYear().toString()}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </ng-container>
                <ng-template #default>
                    <div class="col-md-12" *ngIf="reportData.length >0; else emptyList">
                      
                        <p-table class="ct_bottom_table_tr" #dt [value]="reportData" [rowHover]="true"
                            styleClass="p-datatable-striped" editMode="row">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th
                                        *ngIf="selectMode !=2  && selectedCategory !=14  && selectedCategory !=15 && selectedCategory !=19">
                                        Category
                                    </th>
                                    <th *ngIf="selectedCategory ==19">Product
                                    </th>
                                    <th *ngIf="selectedCategory ==19">No of items
                                    </th>

                                    <th *ngIf="selectMode ==2">Country</th>
                                    <th *ngIf="selectMode ==2">Type of hotel</th>
                                    <th *ngIf="selectMode ==2">Nights per room</th>
                                    <th *ngIf="selectMode ==2">Occupied room</th>
                                    <!-- <th *ngIf="selectMode ==2">Occupied rooms<th> -->
                                    <th *ngIf="selectedCategory==6">Vehicle type</th>
                                    <th *ngIf="selectedCategory==6">No of vehicles</th>
                                    <th *ngIf="selectedCategory==6">Trips per vehicle</th>
                                    <th *ngIf="selectedCategory==13 && selectMode==1">Flight Class</th>
                                    <th *ngIf="selectedCategory==13 && (selectMode==3)">Type</th>
                                    <th *ngIf="selectedCategory==13 && (selectMode==3)">Fuel Type</th>
                                    <th *ngIf="selectedCategory==13 && (selectMode==3 || selectMode ==1)">No of
                                        Passengers
                                    </th>
                                    <th *ngIf="selectedCategory==13 && (selectMode==3 || selectMode ==1)">Distance</th>
                                    <th *ngIf="selectedCategory==13 && (selectMode==3 )">No of Trips</th>
                                    <th *ngIf="selectedCategory==13 && (selectMode ==1)">Business unit</th>
                                    <th *ngIf="selectedCategory==14">No of Commutes</th>
                                    <th *ngIf="selectedCategory==14">Avg Commute Distance</th>
                                    <th *ngIf="selectedCategory == 15">
                                        Type of Home Office

                                    </th>
                                    <th *ngIf="selectedCategory == 15">
                                        No of days

                                    </th>
                                    <th *ngIf="selectedCategory == 15">
                                        No of employees

                                    </th>
                                    <th *ngIf="selectedCategory == 15">
                                        No of months

                                    </th>
                                    <th *ngIf="selectedCategory==18 ">Sub Activity</th>
                                    <th *ngIf="selectedCategory==18">Processing Activity</th>
                                    <th *ngIf="selectedCategory==18">Calculation Method</th>
                                    <th
                                        *ngIf="selectedCategory==20 || selectedCategory ==16 || selectedCategory ==22 || selectedCategory ==21 ||  selectedCategory ==1 || selectedCategory ==23 || selectedCategory ==8 || selectedCategory ==12">
                                        Sub Category</th>
                                    <th *ngIf="selectedCategory == 10 || selectedCategory == 17">
                                        Sub Category

                                    </th>
                                    <th *ngIf="selectedCategory == 10 || selectedCategory == 17">
                                        Distance Travelled

                                    </th>
                                    <th *ngIf="selectedCategory == 10 || selectedCategory == 17">
                                        Mass of Product

                                    </th>
                                    <th *ngIf="selectedCategory == 10 || selectedCategory == 17">
                                        Storage facility

                                    </th>
                                    <th *ngIf="selectedCategory==20">Total Waste</th>
                                    <th *ngIf="selectedCategory==20">Landfill</th>
                                    <th *ngIf="selectedCategory==20">Combustion</th>
                                    <th *ngIf="selectedCategory==20">Recycling</th>
                                    <th *ngIf="selectedCategory==20">Composing</th>
                                    <th>Year</th>
                                    <th *ngIf="selectedCategory !=15">Month</th>
                                    <th *ngIf="selectedCategory==11">
                                        Water Supply
                                    </th>
                                    <th *ngIf="selectedCategory==11">
                                        Water Treated
                                    </th>
                                    <th *ngIf="selectedCategory==2">
                                        Refrigerant Amount
                                    </th>
                                    <th
                                        *ngIf="selectedCategory==1 || selectedCategory==3 || selectedCategory==10|| selectedCategory==17 || selectedCategory ==16 || selectedCategory ==23 || selectedCategory ==22 ||  selectedCategory ==21  || selectedCategory ==23 || selectedCategory ==23 || selectedCategory ==8 || selectedCategory ==12">
                                        Quantity
                                    </th>

                                    <th *ngIf="selectedCategory==5 || selectedCategory==7">
                                        Reading Value
                                    </th>
                                    <th *ngIf="selectedCategory==5">
                                        Source Name
                                    </th>
                                    <th *ngIf="selectedCategory==7 || selectedCategory == 5"
                                        pSortableColumn="noofairconnUnits" pTooltip="Amount of refrigent used"
                                        tooltipPosition="top">
                                        Energy
                                    </th>
                                    <th *ngIf="selectedCategory==3" tooltipPosition="top">
                                        No of Extinguisher
                                    </th>
                                    <th pTooltip="Amount of Emission" tooltipPosition="top">
                                        Emission
                                    </th>
                                    <th *ngIf="selectedCategory !=13 && selectedCategory !=15">
                                        Unit
                                    </th>

                                    <!-- <th  *ngIf="selectedCategory == 11">
                                    Water Treatment
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 11">
                                    Water Supply
                                </th>
                             
                                <th  *ngIf="selectedCategory == 20">
                                    Combustion
                                </th>
                                <th  *ngIf="selectedCategory == 20">
                                    Composing
                                </th>
                                <th  *ngIf="selectedCategory == 20">
                                    Landfill
                                </th>
                                <th  *ngIf="selectedCategory == 20">
                                    Recycling
                                </th>
                                <th 
                                    *ngIf="selectedCategory == 16 || selectedCategory == 21 || selectedCategory == 22 || selectedCategory == 23">
                                    Sub Category
                                   
                                </th> -->
                                    <!-- <th  *ngIf="selectedCategory == 18">
                                    Sub Activity
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 23">
                                    Investment type
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 18">
                                    Processing Activity
                                    
                                 </th> -->
                                    <!-- <th 
                                    *ngIf="selectedCategory == 16 || selectedCategory ==18 || selectedCategory == 21 ||selectedCategory == 22 ||selectedCategory == 23">
                                    Calculation Method
                                   
                                </th>
                                <th 
                                    *ngIf="selectedCategory == 16 || selectedCategory == 21 ||selectedCategory == 22">
                                    Franchise Space
                                   
                                </th>
                                <th 
                                    *ngIf="selectedCategory == 16 || selectedCategory ==18 || selectedCategory == 21 ||selectedCategory == 22">
                                    Scope 1 Emission
                                   
                                </th>
                                <th 
                                    *ngIf="selectedCategory == 16 || selectedCategory ==18 || selectedCategory == 21 ||selectedCategory == 22">
                                    Scope 2 Emission
                                   
                                </th> -->
                                    <!-- <th  *ngIf="selectedCategory == 15">
                                    Type of Home Office
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 15">
                                    No of days
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 15">
                                    No of employees
                                   
                                </th> -->
                                    <!-- <th  *ngIf="selectedCategory == 15">
                                    No of months
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 14">
                                    Type
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 14">
                                    Average Employee Commute
                                   
                                </th> -->
                                    <!-- <th  *ngIf="selectedCategory == 14">
                                    Average Commuted Distance
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 14">
                                    Working Days
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 10 || selectedCategory == 17">
                                    Vehicle Type
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 12">
                                    Method
                                   
                                </th>
                                <th  *ngIf="selectedCategory == 12">
                                    Waste Type
                                   
                                </th>
                          
                                <th pTooltip="Data Points" tooltipPosition="top" pSortableColumn="subcatName"
                                    *ngIf="selectedCategory == 1 || selectedCategory == 2 || selectedCategory == 3 || selectedCategory == 4 || selectedCategory == 5 || selectedCategory == 6">
                                    D.P
                                   
                                </th>

                                <th *ngIf="selectedCategory==1 || selectedCategory==5 || selectedCategory==7 || selectedCategory==8"
                                    pTooltip="Reading Value" tooltipPosition="top" pSortableColumn="readingValue">
                            
                                    Value

                                </th>
                                <th *ngIf="selectedCategory==1" pTooltip="Blend Type" tooltipPosition="top"
                                    pSortableColumn="BlendType">
                         
                                    Blend

                                </th> -->
                                    <!-- <th *ngIf="selectedCategory==1" style="width: 15%" pTooltip="Blend percent"
                                    tooltipPosition="top" pSortableColumn="blendPercent">
                                    <p-sortIcon field="blendPercent"></p-sortIcon>
                                    %

                                </th> -->
                                    <!-- 
                                <th *ngIf="selectedCategory==2" pSortableColumn="noofairconnUnits"
                                    pTooltip="Amount of refrigent used" tooltipPosition="top">
                                    Refrigerant Amount <p-sortIcon field="noofairconnUnits"></p-sortIcon>
                                </th>
                              
                                <th *ngIf="selectedCategory==3" pSortableColumn="numberOfExtinguisher"
                                    pTooltip="Number Of Fire Extinguisher" tooltipPosition="top">
                                    Extinguisher <p-sortIcon field="numberOfExtinguisher"></p-sortIcon>
                                </th>
                                <th *ngIf="selectedCategory==3" pSortableColumn="quantityOfCO2makeup"
                                    pTooltip="Quantity Of CO2 makeup" tooltipPosition="top">
                                    CO2 MakeUp <p-sortIcon field="quantityOfCO2makeup"></p-sortIcon>
                                </th>
                                <th *ngIf="selectedCategory==6" pSortableColumn="noOfVehicles"
                                    pTooltip="Number Of Vehicles" tooltipPosition="top">
                                    Vehicles <p-sortIcon field="noOfVehicles"></p-sortIcon>
                                </th>
                                <th *ngIf="selectedCategory==6" pSortableColumn="modeOfDE" pTooltip="Mode Of data entry"
                                    tooltipPosition="top">
                                    Mode <p-sortIcon field="modeOfDE"></p-sortIcon>
                                </th>
                                <th *ngIf="selectedCategory==6" pSortableColumn="amount">
                                    Amount <p-sortIcon field="amount"></p-sortIcon>
                                </th>
                                <th *ngIf="selectedCategory==5" pSortableColumn="sourceName">
                                    Source <p-sortIcon field="sourceName"></p-sortIcon>
                                </th> -->
                                    <!-- <th >
                                    <p-sortIcon pSortableColumn="status" field="status"></p-sortIcon>
                                    Status
                                    <p-columnFilter field="status" matchMode="equals" display="menu" [showMenu]="true"
                                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown [ngModel]="value" [options]="statusOptions"
                                                (onChange)="filter($event.value)" placeholder="All" [showClear]="false">
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter>

                                </th> -->

                                </tr>

                            </ng-template>
                            <ng-template pTemplate="body" let-de let-editing="editing" let-ri="rowIndex">
                                <tr [pEditableRow]="de">

                                    <td *ngIf="selectedCategory == 1"> {{de.category_name}}</td>
                                    <td *ngIf="selectedCategory == 19"> {{de.product}}</td>
                                    <td *ngIf="selectedCategory == 19"> {{de.no_of_Items}}</td>
                                    <td *ngIf="selectMode==2"> {{de.country_of_stay}}</td>
                                    <td *ngIf="selectMode==2"> {{de.type_of_hotel}}</td>
                                    <td *ngIf="selectMode==2"> {{de.no_of_nights_per_room}}</td>
                                    <td *ngIf="selectMode==2"> {{de.no_of_occupied_rooms}}</td>
                                    <td *ngIf=" selectedCategory ==20"> {{de.type_of_fuel}}</td>
                                    <td
                                        *ngIf="selectedCategory == 2 || selectedCategory == 3 || selectedCategory == 5 || selectedCategory == 6 || selectedCategory == 7  || selectedCategory == 11">
                                        {{de.item}}</td>
                                    <td *ngIf="selectedCategory == 6"> {{de.vehicleName}}</td>
                                    <td *ngIf="selectedCategory == 6"> {{de.No_of_vehicles}}</td>
                                    <td *ngIf="selectedCategory == 6"> {{de.TotalnoOftripsPerVehicle}}</td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==1)"> {{de.flight_type}}</td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==1)"> {{de.flight_class}}</td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==3)"> {{de.vehicle_type}}</td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==3)"> {{de.type}}</td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==3)"> {{de.fuel_type}}</td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==3 || selectMode ==1)">
                                        {{de.no_of_passengers}}</td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==3 || selectMode ==1)">
                                        {{de.distance}}
                                    </td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==3)"> {{de.no_of_trips}}</td>
                                    <td *ngIf="selectedCategory == 13 && (selectMode==1)"> {{de.business_unit}}</td>
                                    <td *ngIf="selectedCategory == 14"> {{de.allemployeescommute}}</td>
                                    <td *ngIf="selectedCategory == 14"> {{de.avgcommutedistance}}</td>
                                    <td *ngIf="selectedCategory == 15 && de.typeofhomeoffice == '1'">With Cooling</td>
                                    <td *ngIf="selectedCategory == 15 && de.typeofhomeoffice == 2">With Heating</td>
                                    <td *ngIf="selectedCategory == 15 && de.typeofhomeoffice == 3">No Cooling / No
                                        Heating
                                    </td>
                                    <td *ngIf="selectedCategory == 15">{{ de.noofdays }}</td>
                                    <td *ngIf="selectedCategory == 15">{{ de.noofemployees }}</td>
                                    <td *ngIf="selectedCategory == 15">{{ de.noofmonths }}</td>
                                    <td
                                        *ngIf="selectedCategory == 8 || selectedCategory == 10 || selectedCategory ==17 || selectedCategory ==23 || selectedCategory ==12 || selectedCategory ==16 || selectedCategory ==18 || selectedCategory ==22 || selectedCategory ==21 ">
                                        {{de.category}}</td>
                                    <td *ngIf=" selectedCategory ==18 "> {{de.sub_activity}}</td>
                                    <td *ngIf="selectedCategory == 18">{{ de.processing_acitivity }}</td>
                                    <td *ngIf=" selectedCategory ==18 "> {{de.calculation_method}}</td>
                                    <!-- <td *ngIf=" selectedCategory ==18 "> {{de.ca}}</td> -->
                                    <!-- <td  *ngIf="selectedCategory == 2"> {{de.item}}</td> -->
                                    <!-- <td> {{de.item}}</td> -->
                                    <td
                                        *ngIf="selectedCategory == 1 || selectedCategory == 8 || selectedCategory == 10 || selectedCategory == 17 || selectedCategory ==23 || selectedCategory ==12 || selectedCategory ==16 || selectedCategory ==20 || selectedCategory ==22 || selectedCategory ==21">
                                        {{ de.subcategory }}</td>
                                    <td *ngIf="selectedCategory == 10 || selectedCategory == 17">{{
                                        de.distance_travelled_km
                                        }}</td>
                                    <td *ngIf="selectedCategory == 10 || selectedCategory == 17">{{
                                        de.mass_of_product_trans
                                        }}</td>
                                    <td *ngIf="selectedCategory == 10 || selectedCategory == 17">{{
                                        de.storage_facility_type
                                        }}</td>
                                    <td *ngIf="selectedCategory == 20 ">{{ de.total_waste }}</td>
                                    <td *ngIf="selectedCategory == 20 ">{{ de.combustion }}</td>
                                    <td *ngIf="selectedCategory == 20 ">{{ de.composing }}</td>
                                    <td *ngIf="selectedCategory == 20 ">{{ de.landfill }}</td>
                                    <td *ngIf="selectedCategory == 20 ">{{ de.recycling }}</td>

                                    <td>
                                        {{ de.year }}
                                    </td>
                                    <td
                                        *ngIf="selectedCategory == 10 || selectedCategory ==22 || selectedCategory ==17 || selectedCategory == 13 || selectedCategory == 19 || selectedCategory == 14  || selectedCategory ==23 || selectedCategory ==1 || selectedCategory ==12 || selectedCategory ==16 || selectedCategory ==18 || selectedCategory ==20 || selectedCategory ==21">
                                        {{ de.month }}
                                    </td>
                                    <td
                                        *ngIf="selectedCategory != 10 && selectedCategory != 19 && selectedCategory != 17 && selectedCategory != 22 && selectedCategory != 13  && selectedCategory != 14  && selectedCategory != 15 &&  selectedCategory !=23  && selectedCategory !=1 && selectedCategory !=12 && selectedCategory !=16 && selectedCategory !=18 && selectedCategory !=20 && selectedCategory !=21 ">
                                        {{ de.months }}
                                    </td>
                                    <td *ngIf="selectedCategory == 11 ">{{ de.water_supply }}</td>
                                    <td *ngIf="selectedCategory == 11 ">{{ de.water_treatment }}</td>
                                    <td *ngIf="selectedCategory == 2">
                                        {{ de.refamount }}
                                    </td>
                                    <td *ngIf="selectedCategory == 3">
                                        {{ de.numberofextinguisher }}
                                    </td>
                                    <td
                                        *ngIf="selectedCategory==1 || selectedCategory==3 || selectedCategory == 8 || selectedCategory == 10 || selectedCategory == 23 || selectedCategory ==12 || selectedCategory ==16  || selectedCategory ==21 || selectedCategory ==22">
                                        {{ de.quantity }}</td>
                                    <td *ngIf="selectedCategory==5 || selectedCategory==7">{{ de.reading_value }}</td>
                                    <td *ngIf="selectedCategory==5">{{ de.sourcename }}</td>
                                    <td *ngIf="selectedCategory==5 || selectedCategory==7">{{ de.energy }}</td>
                                    <td> {{de.emission | number: '1.4-4'}}</td>
                                    <td *ngIf="selectedCategory != 20 && selectedCategory != 15 ">{{ de.unit }}</td>
                                    <td *ngIf="selectedCategory == 20 ">{{ de.waste_unit }}</td>

                                    <!-- <td *ngIf="selectedCategory == 8"> {{de.typeofpurchase}}</td>
                             
                             
                          
                                <td *ngIf="selectedCategory == 22 ">{{ de.franchise_type }}</td>
                                <td *ngIf="selectedCategory == 22 || selectedCategory == 23 ">{{ de.sub_category }}</td>

                       
                             
                                <td *ngIf="selectedCategory == 18">{{ de.intermediate_category }}</td>
                                <td *ngIf="selectedCategory == 18">{{ de.sub_activity }}</td>
                                <td *ngIf="selectedCategory == 18">{{ de.processing_acitivity }}</td>
                                <td *ngIf="selectedCategory == 16 || selectedCategory == 21">{{ de.sub_category }}</td>
                                <td
                                    *ngIf="selectedCategory == 16 || selectedCategory ==18 || selectedCategory == 21 ||selectedCategory == 22 ||selectedCategory == 23">
                                    {{ de.calculation_method }}</td>
                                <td *ngIf="selectedCategory == 16 || selectedCategory == 21 ||selectedCategory ==22">{{
                                    de.franchise_space }}</td>
                                <td *ngIf="selectedCategory == 18 ">{{ de.scope1emissions }}</td>
                                <td *ngIf="selectedCategory == 18 ">{{ de.scope2emissions }}</td>

                                <td
                                    *ngIf="selectedCategory == 16 || selectedCategory == 21 || selectedCategory == 22   ">
                                    {{ de.scope1_emission }}</td>
                                <td
                                    *ngIf="selectedCategory == 16 || selectedCategory == 21 || selectedCategory == 22  ">
                                    {{ de.scope2_emission }}</td>
                       
                                <td *ngIf="selectedCategory == 14">{{ de.type }}</td>
                                <td *ngIf="selectedCategory == 14">{{ de.allemployeescommute }}</td>
                                <td *ngIf="selectedCategory == 14">{{ de.avgcommutedistance }}</td>
                                <td *ngIf="selectedCategory == 14">{{ de.workingdays }}</td>
                                <td *ngIf="selectedCategory == 12">{{ de.method }}</td>
                                <td *ngIf="selectedCategory == 12">{{ de.waste_type }}</td>
                              
                                <td *ngIf="selectedCategory == 10 || selectedCategory == 17">{{ de.vehicle_type }}</td>
                                <td *ngIf="selectedCategory == 10 || selectedCategory == 17">{{ de.sub_category }}</td>
                                <td *ngIf="selectedCategory == 10 || selectedCategory == 17">{{ de.distance_travelled_km
                                    }}</td>
                                <td *ngIf="selectedCategory == 10 || selectedCategory == 17">{{ de.mass_of_product_trans
                                    }}</td>
                                <td *ngIf="selectedCategory == 10 || selectedCategory == 17">{{ de.storage_facility_type
                                    }}</td> -->

                                    <!-- <td *ngIf="selectedCategory==1 || selectedCategory==5 || selectedCategory==7">
                                    <p-cellEditor><ng-template pTemplate="input">
                                            <input name="readingValue_{{ ri }}" id="{{ ri }}" pInputText type="text"
                                                [(ngModel)]="de.readingValue" ngModel #readingValue="ngModel">
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ de.readingValue }}
                                        </ng-template>{{ de.readingValue }}</p-cellEditor>
                                </td> -->
                                    <!-- <td *ngIf="selectedCategory==1">{{ de.blendType }}</td> -->

                                    <!-- <td *ngIf="selectedCategory==1"><p-cellEditor><ng-template pTemplate="input">
                                            <input name="blendPercent_{{ ri }}" id="{{ ri }}" pInputText type="text"
                                                [(ngModel)]="de.blendPercent" ngModel #blendPercent="ngModel">
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ de.blendPercent }}
                                        </ng-template>{{ de.blendPercent }}</p-cellEditor></td> -->

                                    <!-- <td *ngIf="selectedCategory==2"><p-cellEditor><ng-template pTemplate="input">
                                            <input name="refAmount_{{ ri }}" id="{{ ri }}" pInputText type="text"
                                                [(ngModel)]="de.refAmount" ngModel #refAmount="ngModel">
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ de.refAmount }}
                                        </ng-template>{{ de.refAmount }}</p-cellEditor></td> -->
                                    <!-- <td *ngIf="selectedCategory==2"><p-cellEditor><ng-template pTemplate="input">
                                            <input name="cO2LeakagePerUnit_{{ ri }}" id="{{ ri }}" pInputText
                                                type="text" [(ngModel)]="de.cO2LeakagePerUnit" ngModel
                                                #cO2LeakagePerUnit="ngModel">
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ de.cO2LeakagePerUnit }}
                                        </ng-template>{{ de.cO2LeakagePerUnit }}</p-cellEditor></td>
                                <td *ngIf="selectedCategory==2"><p-cellEditor><ng-template pTemplate="input">
                                            <input name="capacity_{{ ri }}" id="{{ ri }}" pInputText type="text"
                                                [(ngModel)]="de.capacity" ngModel #capacity="ngModel">
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ de.capacity }}
                                        </ng-template>{{ de.capacity }}</p-cellEditor></td>
                                <td *ngIf="selectedCategory==2"><p-cellEditor><ng-template pTemplate="input">
                                            <input name="leakagePerOfCapacity_{{ ri }}" id="{{ ri }}" pInputText
                                                type="text" [(ngModel)]="de.leakagePerOfCapacity" ngModel
                                                #leakagePerOfCapacity="ngModel">
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ de.leakagePerOfCapacity }}
                                        </ng-template>{{ de.leakagePerOfCapacity }}</p-cellEditor></td> -->


                                    <!--                                 
                                <td *ngIf="selectedCategory==6"><p-cellEditor><ng-template pTemplate="input">
                                            <input name="amount_{{ ri }}" id="{{ ri }}" pInputText type="text"
                                                [(ngModel)]="de.amount" ngModel #amount="ngModel">
                                        </ng-template>
                                        <ng-template pTemplate="output">

                                            {{ de.amount }}
                                        </ng-template>{{ de.amount }}</p-cellEditor></td>
                                <td *ngIf="selectedCategory==5">{{ de.sourceName }}</td> -->



                                    <!-- <td>
                                    <div class="view-details">
                                        <i class="pi pi-eye pt-2 text-white" title="info"
                                            [routerLink]="['/tracking-status']"
                                            [queryParams]="{data:de.subcategoryID}"></i>
                                        <a *ngIf="de.fileName" (click)="downloadFile(de.fileName)">
                                            <i class="pi pi-download text-white pl-2" title="download"></i></a>
                                    </div>
                                </td> -->
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </ng-template>
                <ng-template #emptyList>
                    <p class="nodata text-dark">No data available</p>
                </ng-template>
            </div>
        </div>
    </div>
</div>